import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  invoicesList: [],
  totalPages: 0,
  invoiceDetails: {},
  invoicePayments: [],
  workOrderPayments: [],
  additionalItemWorkOrderDetails: [],
  projectWorkOrders: [],
};
export const InvoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    getInvoicesList: (state, action) => {
      state.invoicesList = action.payload.items;
      state.totalPages = action.payload.totalPages;
    },
    setInvoiceDetails: (state, action) => {
      state.invoiceDetails = action.payload;
    },
    setInvoicePayments: (state, action) => {
      state.invoicePayments = action.payload;
    },
    setWorkOrderPayments: (state, action) => {
      state.workOrderPayments = action.payload;
    },
    setAdditionalItemWorkOrderDetails: (state, action) => {
      state.additionalItemWorkOrderDetails = action.payload;
    },
    setProjectWorkOrders: (state, action) => {
      state.projectWorkOrders = action.payload;
    },
    resetWorkorderProjects: (state) => {
      state.projectWorkOrders = [];
    },
  },
});

export const {
  getInvoicesList,
  setInvoiceDetails,
  setInvoicePayments,
  setWorkOrderPayments,
  setAdditionalItemWorkOrderDetails,
  setProjectWorkOrders,
  resetWorkorderProjects,
} = InvoicesSlice.actions;
export default InvoicesSlice.reducer;
